import React from 'react'
import { compose } from 'redux'
import { connect, } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form';
import { withContainerCrud } from '../../../../../components/Utils';
import { salvar, listar } from "../../actions";
import CriarCustomPesquisa from '../CriarCustomPesquisa'

import { listar as listarPerfis } from '../../../../admin/ConsultaPerfisAdmin/actions'

const mapStateToProps = (state, props) => {
    const { CriarCustomFormReducer } = state
    let initialValues = {
        componenteRoot: {
            label: "Arvore de Componentes",
            uid: Math.random().toString(36).substring(7),
            componentes: []
        }
    }
    let atualValues = getFormValues('CriarCustomForm')(state)

    const pesquisa = <CriarCustomPesquisa />;
    let customFormUid = null;
    if (atualValues)
        customFormUid = atualValues.uid

    return {
        initialValues,
        permiteNovo: true,
        pesquisa,
        atualValues,
        customFormUid,
        crudControl: CriarCustomFormReducer.rCrudSalvar,
    };
};


export default compose(
    connect(mapStateToProps, { salvar, listarPerfis }),
    reduxForm({
        form: 'CriarCustomForm',
    }),
    withContainerCrud({ titulo: "Cadastro de Formulário" })
);


// WEBPACK FOOTER //
// ./src/routes/sistema/CriarCustomForm/components/CriarCustomForm/CriarCustomForm.enhancer.js